<template>
  <v-img src="@/assets/pages/form/recurso-form2.webp">
    <v-container
      class="py-12"
      fluid
      style="height: 100%; display: flex; align-items: center"
    >
      <v-row align="center" justify="center">
        <v-col cols="10" sm="8" md="6" class="d-flex d-lg-none">
          <v-img
            height="100%"
            contain
            src="@/assets/pages/form/geometric_form2_mobile.png"
          >
            <v-card
              height="100%"
              color="transparent"
              outlined
              class="white--text d-flex"
              style="padding: 1rem 1rem 28% 1rem"
            >
              <v-layout column align-center justify-space-around>
                <h1 class="h1_card_sect1" style="font-size: 1.2rem">
                  ¡PREINSCRÍBETE!
                </h1>
                <span class="content-preinscribete"
                  >Déjanos tus datos para brindarte mayor información sobre
                  nuestras carreras y programas.</span
                >
              </v-layout>
            </v-card>
          </v-img>
        </v-col>
        <v-col
          class="d-none d-lg-flex card-preinscribete-desktop card-preinscribete-ultra"
          cols="12"
          sm="12"
          md="4"
        >
          <v-img
            height="100%"
            contain
            class="pa-1"
            src="@/assets/pages/form/geometric_form2.webp"
          >
            <v-card
              height="100%"
              color="transparent"
              outlined
              class="white--text padding-card-custom d-flex"
            >
              <v-layout column align-start justify-center>
                <h1 class="h1_card_sect1 mb-3" style="font-size: 2rem">
                  ¡PREINSCRÍBETE!
                </h1>
                <span :class="margin_top" style="font-size: 0.8rem"
                  >Déjanos tus datos para brindarte mayor información sobre
                  nuestras carreras y programas.</span
                >
              </v-layout>
            </v-card>
          </v-img>
        </v-col>
        <v-col cols="10" sm="10" md="8" lg="6" xl="6" class="pa-3">
          <v-card
            style="
              border-radius: 24px 24px 24px 24px !important;
              background-color: rgba(255, 255, 255, 0.88) !important;
              min-height: 275px !important;
            "
            class="card_form pa-md-10"
          >
            <v-form
              action="https://formsubmit.co/columbiawebmaster17@gmail.com"
              method="post"
              ref="form"
              v-model="valid"
              lazy-validation
            >
              <v-row>
                <v-col cols="12" lg="6" md="12" sm="12" class="pa-3">
                  <v-text-field
                    class="label-form"
                    v-model="name"
                    name="Nombres"
                    :counter="25"
                    maxlength="25"
                    :rules="nameRules"
                    label="Nombres Completos"
                    prepend-icon="mdi mdi-card-account-details-outline info--text"
                    required
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" lg="6" md="12" sm="12" class="pa-3">
                  <v-text-field
                    class="label-form"
                    v-model="apellidos"
                    name="Apellidos"
                    :counter="25"
                    maxlength="25"
                    :rules="apellidoPaternoRules"
                    label="Apellidos Completos"
                    prepend-icon="mdi mdi-card-account-details-outline info--text"
                    required
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <!-- <v-col cols="12" lg="6" md="12" sm="12" class="pa-3">
                  <v-text-field
                    class="label-form"
                    v-model="apellidoMaterno"
                    name="Apellido materno"
                    :counter="25"
                    maxlength="25"
                    :rules="apellidoMaternoRules"
                    label="Apellido materno"
                    prepend-icon="mdi mdi-card-account-details-outline info--text"
                    required
                  >
                  </v-text-field>
                </v-col> -->
                <v-col cols="12" lg="6" md="12" sm="12" class="pa-3">
                  <v-text-field
                    class="label-form"
                    v-model="dni"
                    name="Dni"
                    type="text"
                    :counter="15"
                    :rules="dniRules"
                    label="DNI"
                    prepend-icon="mdi mdi-card-account-details-outline info--text"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" lg="6" md="12" sm="12" class="pa-3">
                  <v-text-field
                    class="label-form"
                    v-model="phone"
                    name="Celular"
                    type="number"
                    :counter="9"
                    :rules="phoneRules"
                    label="Celular"
                    prepend-icon="mdi mdi-cellphone info--text"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" lg="6" md="12" sm="12" class="pa-3">
                  <v-text-field
                    class="label-form"
                    type="email"
                    v-model="email"
                    name="Email"
                    :rules="emailRules"
                    label="Correo Electrónico"
                    prepend-icon="mdi mdi-email-outline info--text"
                    required
                  ></v-text-field>
                  
                </v-col>
                <v-col cols="12" lg="6" md="12" sm="12" class="pa-3">
                  <v-select
                    class="label-form"
                    name="Carrera de interés"
                    :items="carreras"
                    :rules="[(v) => !!v || 'Debe elegir una opción']"
                    label="Carrera o programa de interés"
                    prepend-icon="mdi mdi-book-education-outline info--text"
                    required
                    append-icon="mdi-chevron-down"
                  ></v-select>
                </v-col>
                <!-- <v-col cols="12" lg="6" md="12" sm="12" class="pa-3">
                  <v-select
                    class="label-form"
                    name="Distrito"
                    :items="distritos"
                    :rules="[(v) => !!v || 'Debe elegir una opción']"
                    label="Distrito"
                    prepend-icon="mdi mdi-map-marker-radius-outline info--text"
                    required
                    append-icon="mdi-chevron-down"
                  ></v-select>
                </v-col> -->
              </v-row>
              <!-- <v-row> -->
                <!-- <v-col cols="12" lg="6" md="12" sm="12" class="pa-3">
                  <v-select
                    class="label-form"
                    name="Carrera de interés"
                    :items="carreras"
                    :rules="[(v) => !!v || 'Debe elegir una opción']"
                    label="Carrera o programa de interés"
                    prepend-icon="mdi mdi-book-education-outline info--text"
                    required
                    append-icon="mdi-chevron-down"
                  ></v-select>
                </v-col>
                <v-col cols="12" lg="6" md="12" sm="12" class="pa-3">
                  <v-select
                    class="label-form"
                    name="Estado Académico"
                    :items="estadoAcademico"
                    :rules="[(v) => !!v || 'Debe elegir una opción']"
                    label="Estado académico actual"
                    prepend-icon="mdi mdi-school-outline info--text"
                    required
                    append-icon="mdi-chevron-down"
                  ></v-select>
                </v-col> -->
              <!-- </v-row> -->
              <v-row>
                <v-col cols="12">
                  <v-checkbox
                    class="checkbox-form info--text ma-0"
                    :rules="[(v) => !!v || 'Debe Aceptar para Continuar!']"
                    label="Acepto la Política de Privacidad y Protección de Datos Personales"
                    :on-icon="'mdi-circle-slice-8'"
                    :off-icon="'mdi-circle-outline'"
                    required
                  >
                  </v-checkbox>
                </v-col>
                <v-col cols="12">
                  <v-btn type="submit" class="btn-form" small @click="validate">
                    ENVIAR
                  </v-btn>
                </v-col>
                <input
                  type="hidden"
                  name="_next"
                  value="https://www.columbia.edu.pe/gracias"
                />
                <input type="hidden" name="_captcha" value="false" />
                <input type="hidden" name="_template" value="box" />
                <input type="hidden" name="_subject" v-model="email" />
              </v-row>
            </v-form>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-img>
</template>

<script>
import Vue from "vue";
import colors from "vuetify/lib/util/colors";

//
//  alert("La resolución de tu pantalla es: " + screen.width + " x " + screen.height);

export default Vue.extend({
  name: "Form",
  data: () => ({
    subject: "Segundo correo",
    padding_form: "",
    margin_left: "mx-auto",
    margin_top: "",
    margin_top2: "",
    pa1: "px-16",
    font_size_text: "",
    font_size_title: "",
    section_height: "",
    name: "",
    apellidoPaterno: "",
    apellidoMaterno: "",
    padding: "",
    height_img: "",
    btn_position: "",
    valid: true,
    nameRules: [
      (v) => !!v || "Nombre es requeridos",
      (v) =>
        (v && v.length > 3) || "El Nombre debe contener más de 3 carácteres",
      (v) =>
        (v && v.length <= 30) ||
        "El nombre debe contener menos de 30 carácteres",
    ],
    apellidoPaternoRules: [
      (v) => !!v || "Apellidos son requeridos",
      (v) =>
        (v && v.length > 3) ||
        "Los Apellidos deben contener mas de 3 carácteres",
      (v) =>
        (v && v.length <= 25) ||
        "Los apellidos deben contener menos de 25 carácteres",
    ],
    apellidoMaternoRules: [
      (v) => !!v || "Apellido materno es requerido",
      (v) =>
        (v && v.length > 3) ||
        "El apellido materno debe contener mas de 3 carácteres",
      (v) =>
        (v && v.length <= 25) ||
        "El nombre debe contener menos de 25 carácteres",
    ],
    phone: "",
    dniRules: [
      (v) => !!v || "Número de documento es requerido",
      (v) =>
        (v && v.toString().length <= 15) ||
        "Número de documento debe contener máximo 15 dígitos",
      // v => (v && v.length > 6) || '#restriccion',
      // v => (v && v.length <= 25) || '#restriccion',
    ],
    phoneRules: [
      (v) => !!v || "Número de celular es requerido",
      (v) =>
        (v && v.toString().length <= 9) ||
        "Número de celular debe contener máximo 9 dígitos",
      (v) => {
        const REGEX_PHONE = /^[9][0-9]{8}$/;
        return REGEX_PHONE.test(v) || "Número de celular invalido";
      },
      // v => (v && v.length > 6) || '#restriccion',
      // v => (v && v.length <= 25) || '#restriccion',
    ],
    email: "",
    emailRules: [
      (v) => !!v || "E-mail es requerido",
      (v) => /.+@.+\..+/.test(v) || "E-mail debe ser valido",
    ],
    select: null,
    distritos: [
      "ANCON",
      "ATE",
      "BARRANCO",
      "BREÑA",
      "CARABAYLLO",
      "CHACLACAYO",
      "CHORRILOS",
      "CIENEGUILLA",
      "COMAS",
      "EL AGUSTINO",
      "INDEPENCIA",
      "JESÚS MARÍA",
      "LA MOLINA",
      "LA VICTORIA",
      "LIMA",
      "LINCE",
      "LOS OLIVOS",
      "LURIGANCHO",
      "LURIN",
      "MAGDALENA DEL MAR",
      "MIRAFLORES",
      "PACHACAMAC",
      "PUCUSANA",
      "PUEBLO LIBRE",
      "PUENTE PIEDRA",
      "PUNTA HERMOSA",
      "PUNTA NEGRA",
      "RIMAC (SOLO URB. PIEDRA LIZA)",
      "RIMAC (EXCEPTO URB. PIED. LIZA)",
      "SAN BARTOLO",
      "SAN BORJA",
      "SAN ISIDRO",
      "SAN JUAN DE LURIGANCHO",
      "SAN JUAN DE MIRAFLORES",
      "SAN LUIS",
      "SAN MARTIN DE PORRES",
      "SAN MIGUEL",
      "SANTA ANITA",
      "SANTA ROSA",
      "SANTIAGO DE SURCO",
      "SURQUILLO",
      "VILLA EL SALVADOR",
      "VILLA MARIA DEL TRIUNFO",
      "CALLAO (Cercado)",
      "BELLAVISTA",
      "CARMEN DE LA LEGUA - REYNOSO",
      "LA PERLA",
      "LA PUNTA",
      "VENTANILLA",
      "OTRO",
    ],
    carreras: [
      "Hotelería internacional",
      "Alta cocina",
      "Bartender",
      "Pastelería y panadería",
      "Aviación comercial",
      "Servicio y hospitalidad en vuelos comerciales",
      "Counter",
      "Servicio y atención de viajeros a bordo",
      "Programa de Inglés"
    ],
    estadoAcademico: [
      "Estoy en 5to de secundaria",
      "Estoy en 4to o 3ero de secundaria",
      "Ya terminé la secundaria",
      "Estoy estudiando en un instituto",
      "Soy egresado de instituto",
      "Estoy estudiando en una universidad",
    ],
    checkbox: false,
  }),

  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  },

  methods: {
    validate(event) {
      if (!this.$refs.form.validate()) {
        return event.preventDefault();
      }
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    onResize() {
      if (window.innerWidth <= 600) {
        this.btn_position = "button_position_sm";
        this.pa1 = "pa-1";
        this.padding_form = "pa-10";
        this.padding = "";
        this.font_size_text = "109% !important";
        this.height_img = "172px !important";
        this.font_size_title = "184% !important";
        this.margin_top = "mt-0";
        this.margin_top2 = "";
        this.section_height = "1535px !important";
      } else if (window.innerWidth > 600 && window.innerWidth < 1000) {
        this.section_height = "1250px !important";
      } else if (window.innerWidth > 1000 && window.innerWidth < 1650) {
        this.padding_form = "";
        this.padding = "pa-12";
        this.pa1 = "px-8";
        this.height_img = "208px !important";
        this.font_size_text = "112% !important";
        this.font_size_title = "233% !important";
        this.margin_top = "mt-2";
        this.margin_top2 = "mt-10";
        this.section_height = "650px !important";
        this.btn_position = "";
      } else if (window.innerWidth > 1650) {
        this.padding_form = "";
        this.padding = "pa-12";
        this.height_img = "248px !important";
        this.font_size_text = "120% !important";
        this.font_size_title = "250% !important";
        this.margin_top = "mt-2";
        this.margin_top2 = "mt-10";
        this.pa1 = "px-8";
        this.section_height = "650px !important";
        this.btn_position = "";
      } else {
        this.pa1 = "px-8";
        this.padding_form = "";
        this.padding = "";
        this.height_img = "206px !important";
        this.font_size_text = "";
        this.font_size_text = "100% !important";
        this.font_size_title = "270% !important";
        this.section_height = "650px !important";
        this.btn_position = "";
      }
    },
  },
});
</script>
<style>
.card_form {
  border-radius: 24px 24px 24px 24px !important;
  background-color: rgba(255, 255, 255, 0.88) !important;
  min-height: 275px !important;
}

@media only screen and (max-width: 600px) {
  .card_form {
    padding: 20px !important;
  }
}

@media only screen and (max-width: 1000px) {
  .card_form {
    padding: 20px !important;
    background-color: transparent;
  }
}

.v-img_card_form {
  max-height: 271px;
  max-width: 622px;
}

.button_position_sm {
  margin-top: -50px;
  margin-left: 50px;
}

.label-form .v-label {
  color: black !important;
  opacity: 1;
}

.checkbox-form .v-label {
  color: black !important;
  opacity: 1;
  font-size: 0.8em;
}
.btn-form {
  width: 120px;
  background-color: #0077ff !important;
}
.btn-form span {
  font-size: 1em;
  color: #ffffff;
}

.v-icon.mdi-circle-outline,
.v-icon.mdi-circle-slice-8 {
  color: #2196f3;
  caret-color: #2196f3;
}
.padding-card-custom {
  padding: 1rem 6rem 1rem 1rem;
}
.content-preinscribete {
  font-size: 0.75rem;
  text-align: center;
}

@media screen and (min-width: 600px) {
  .content-preinscribete {
    font-size: 1.2rem;
  }
}
@media screen and (max-width: 600px) {
  .label-form label {
    font-size: 0.75rem;
  }
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield;
}

@media (min-width: 1264px) {
  .card-preinscribete-desktop {
    flex: 0 0 30%;
    max-width: 30%;
  }
}
@media (min-width: 1904px) {
  .card-preinscribete-ultra {
    flex: 0 0 22%;
    max-width: 22%;
  }
}
</style>
